.header {
  color: var(--cxy-color-content-default);
  padding: var(--cxy-spacing-2) 0;
}

.dialogWrapper {
  width: 100%;
  height: calc(100vh - 68px);
  grid-template-areas: 'content' 'footer';
  display: grid;
  grid-template-rows: auto 150px;
}

.content {
  grid-area: content;
}

.footer {
  grid-area: footer;
  margin-block: var(--cxy-spacing-8) 68px calc(var(--cxy-spacing-8) + env(safe-area-inset-bottom));
}

.applyButton {
  height: 50px;
  text-transform: uppercase;
}

.scroll {
  overflow-y: auto;
}

.filtersButton {
  display: flex;
  align-items: center;
  gap: var(--cxy-spacing-1);
}
.filtersButton > .filtersCount {
  margin-inline-end: -4px;
}

/* Gazzetta theme overrides */
[data-fpsm-theme='gazzetta'] {
  --window-height: calc(var(--parent-window-height, 100%) - var(--parent-header-height));
  --dialog-wrapper-padding-y: var(--cxy-spacing-4);
  --dialog-close-button-height: 84px;
  --dialog-footer-height: 54px;
  --dialog-wrapper-height: calc(
    var(--window-height) - var(--dialog-close-button-height) - var(--dialog-wrapper-padding-y)
  );
  --dialog-content-height: calc(var(--dialog-wrapper-height) - var(--dialog-footer-height));

  .scroll {
    top: var(--parent-window-top-offset, 0px);
    height: var(--window-height) !important;
  }
  .dialogWrapper {
    grid-template-rows: var(--dialog-content-height) var(--dialog-footer-height);
    height: var(--dialog-wrapper-height);
  }
  .content {
    overflow-y: auto;
  }
  .filtersButton {
    border-radius: 60px;
    background-color: var(--cxy-color-grey-700);
    color: var(--cxy-color-white);
  }
  .applyButton {
    background-color: var(--cxy-color-black);
    color: var(--cxy-color-white);

    &:disabled {
      background-color: var(--cxy-color-grey);
      color: var(--cxy-color-grey-700);
    }
  }
  .filtersButton > .filtersCount {
    margin-inline-end: -4px;
    color: white;
  }
}
